import axios from "axios";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { BASE_URL } from "../../utils/EmpUtil";
import { is401 } from "../../errors/ErrorConstants";

export default class MarketPreferencesClient {
  static baseUrl = BASE_URL;

  static getReservationReleaseStatus(user, selectedMarket = null) {
    let url = `${this.baseUrl}/preferences/release-status`;

    if (selectedMarket !== null) {
      url = url.concat(`?selectedMarket=${selectedMarket}`);
    }

    return axios
      .get(url, getHeaders(user.token))
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static saveReservationReleasePreferences(user, data, selectedMarket) {
    let url = `${this.baseUrl}/preferences/reservation-release/save`;

    if (selectedMarket !== null) {
      url = url.concat(`?selectedMarket=${selectedMarket}`);
    }

    return axios
      .put(url, data, getHeaders(user.token))
      .then(() => Promise.resolve())
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static getAldCupidId(user, marketID = null) {
    let url = `${this.baseUrl}/preferences/ald-cupid-id`;

    if (marketID !== null) {
      url = url.concat(`?selectedMarket=${marketID}`);
    }

    return axios
      .get(url, getHeaders(user.token))
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static getPaymentThreshold(user, marketID = null) {
    let url = `${this.baseUrl}/preferences/paymentThreshold`;
    if (marketID !== null) {
      url = url.concat(`?selectedMarket=${marketID}`);
    }

    return axios
      .get(url, getHeaders(user.token))
      .then((response) => response.data)
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static saveCupidIdPreferences(user, data, selectedMarket) {
    let url = `${this.baseUrl}/preferences/ald-cupid-id/save`;
    if (selectedMarket && selectedMarket.length > 0) {
      url = url.concat(`?selectedMarket=${selectedMarket}`);
    }
    return axios
      .put(url, data, getHeaders(user.token))
      .then(() => Promise.resolve())
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }

  static savePaymentThresholdPreferences(user, data, selectedMarket) {
    let url = `${this.baseUrl}/preferences/paymentThreshold/save`;
    if (selectedMarket && selectedMarket.length > 0) {
      url = url + `?selectedMarket=${selectedMarket}`;
    }
    return axios
      .post(url, data, getHeaders(user.token))
      .then(() => Promise.resolve())
      .catch((error) => {
        if (is401(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}
